<!-- TEMPLATE -->
<template>

    <!-- NAVBAR -->
    <nav id="navbar" class="navbar navbar-expand-md navbar-dark gradient-custom fixed-top py-2">
        <div class="container-fluid">

            <!-- MOBILE BUTTON -->
            <button class="navbar-toggler d-lg-none" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapsibleNavId" aria-controls="collapsibleNavId" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <!-- NAVBAR LIST -->
            <div class="collapse navbar-collapse justify-content-center fw-light" id="collapsibleNavId">
                <ul class="navbar-nav mb-2 mb-lg-0 fs-4">
                    <li class="nav-item mx-2">
                        <a class="nav-link" href="https://kernelhearts.com">Home</a>
                    </li>
                    <!-- <li class="nav-item mx-2">
                        <a class="nav-link" href="#about">About</a>
                    </li>
                    <li class="nav-item mx-2">
                        <a class="nav-link" href="#gallery">Story</a>
                    </li>
                    <li class="nav-item mx-2">
                        <a class="nav-link" href="#characters">Your Squad</a>
                    </li>
                    <li class="nav-item mx-2">
                        <a class="nav-link fw-normal"
                            href="https://store.steampowered.com/app/2902170/Kernel_Hearts/">Wishlist on Steam</a>
                    </li>
                    <li class="nav-item mx-2">
                        <a class="nav-link fw-normal"
                            href="https://store.epicgames.com/es-MX/p/kernel-hearts-809ae2">Wishlist on Epic Games</a>
                    </li> -->
                    <li class="nav-item dropdown mx-2">
                        <a class="nav-link fw-normal dropdown-toggle" href="#" id="buyGameDropdown" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Buy the game ⏷
                        </a>

                        <ul class="dropdown-menu" aria-labelledby="buyGameDropdown">
                            <li>
                                <a class="dropdown-item" href="https://store.epicgames.com/p/kernel-hearts-809ae2" target="_blank">
                                    Epic Games Store
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" href="https://store.steampowered.com/app/2902170/Kernel_Hearts/" target="_blank">
                                    Steam
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" href="https://www.nintendo.com/us/store/products/kernel-hearts-switch-2/" target="_blank">
                                    Nintendo Switch 2
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" href="https://store.playstation.com/product/UP5223-PPSA29916_00-KERNELHEARTS4PS5" target="_blank">
                                    PlayStation 5
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" href="https://www.xbox.com/games/store/kernel-hearts/9nxsnqr7cm1q" target="_blank">
                                    Xbox Series X/S
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item mx-2 ">
                        <a class="nav-link merch-nav fw-normal glowloop" href="https://kerneldrip.com">Merch</a>
                    </li>
                    <li class="nav-item mx-2">
                        <a class="nav-link" href="https://discord.gg/e8NvKhXqrU">Join our Discord</a>
                    </li>
                    <li class="nav-item mx-2">
                        <a class="nav-link" href="https://ephemeragames.com">The Team</a>
                    </li>
                    <!-- <li class="nav-item mx-2">
                        <a class="nav-link" href="https://link.whitethorngames.com/KernelHearts-PressKit">Press Kit</a>
                    </li> -->
                </ul>
            </div>

        </div>
    </nav>

</template>

<!-- SCRIPT -->
<script>
export default {
    name: 'NavbarComponent',
    // props: {},
    data: function () {
        return {}
    },
    // computed: {},
    // methods: {},
    // watch: {},
    // components: {},
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
.navbar {
    width: 100%;
}

.navbar-expand-md,
.navbar-nav {
    flex-wrap: wrap;
    justify-content: center;
}

.nav-link.merch-nav{
    color: rgb(251, 217, 180) !important;
}

.gradient-custom {
    background: linear-gradient(180deg, rgba(20, 0, 40, 0.6) 0%, rgba(60, 0, 240, 0) 100%);
}

ul.navbar-nav a:hover {
    color: #fff !important;
    transition: 0.3s;
    filter: drop-shadow(0px 0px 8px rgba(255, 230, 230, .4));
}

.nav-item.dropdown:hover .dropdown-menu {
    display: block;
}

.nav-item.dropdown .dropdown-toggle::after {
    display: none;
}

.dropdown-item {
    --bs-dropdown-link-hover-bg: var(--color1) !important;
    --bs-dropdown-link-hover-color: var(--color5) !important;
}

.glowloop{
    animation: glowing 2400ms infinite;
}

@keyframes glowing {
  0% { filter: drop-shadow(0px 0px 4px rgba(255, 227, 184, 0.4)); }
  50% { filter: drop-shadow(0px 0px 6px rgba(255, 227, 184, 1)); }
  100% { filter: drop-shadow(0px 0px 4px rgba(255, 227, 184, 0.4)); }
}

// .navbar-nav{
//     border-radius: 20px;
//     background: linear-gradient(90deg, rgba(25, 0, 80, 0.25) 0%, rgba(25, 0, 80, 0.5) 100%);
// }</style>